import { removeSomeSpecialChars } from "@/helpers/jobs";
import React, { useEffect, useMemo, useRef } from "react";

type JobDescriptionNewProps = {
  jobData: jobDescriptionType;
  isMobile: boolean;
};

const JobDescription: React.FC<JobDescriptionNewProps> = ({
  jobData,
  isMobile,
}) => {
  const sanitizedDescription = useMemo(() => {
    return jobData?.description
      ? jobData?.description.replace(
          "[HIDDEN TEXT]",
          "[Confidential Information]",
        )
      : "";
  }, [jobData?.description]);

  const descriptionContent = removeSomeSpecialChars(
    sanitizedDescription,
    "{}?¿�~",
  );
  const keySellingPoints = [
    jobData?.keySellingPoint1,
    jobData?.keySellingPoint2,
    jobData?.keySellingPoint3,
    jobData?.keySellingPoint4,
    jobData?.keySellingPoint5,
  ];
  const spotlightItems = keySellingPoints?.filter(Boolean);

  const descRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (descRef.current) {
      descRef.current.innerHTML = descriptionContent; // Dynamically set the content
    }
  }, [descriptionContent]);

  const descriptionSection = (
    <div>
      <h2 className="mb-3 text-base font-bold leading-6 md:!mb-4 md:!text-lg md:!leading-[26px]">
        Job Description
      </h2>
      <div
        ref={descRef}
        className="break-words text-[13px] leading-6 md:!text-[14px] md:!leading-7"
      ></div>
    </div>
  );
  const spotlightSection = spotlightItems?.length > 0 && (
    <div>
      <div className="mb-3 font-semibold">Spotlight</div>
      <ul className="ml-5">
        {spotlightItems?.map((item, index) => <li key={index}>{item}</li>)}
      </ul>
    </div>
  );
  return (
    <div
      id="jobDescription"
      className={`job-description-content mt-6 flex flex-col gap-6 px-4 pt-4 text-xs md:!mt-0 md:!px-6 md:!pt-8 md:!text-sm${isMobile ? "border-surface-tertiary border-t border-solid" : ""}`}
    >
      {descriptionSection}
      {spotlightSection}
    </div>
  );
};

export default JobDescription;
